import isNil from 'ramda/src/isNil';

/**
 * Predicate for orphan marketplaces, that is without a parentMarketplaceId
 * @param marketplace
 */
export const orphan = (marketplace: { parentMarketplaceId?: string }): boolean =>
  isNil(marketplace.parentMarketplaceId);
